/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ErrorPage.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali
 *
 * @Date			  : Sep 30, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali (H175591)
 * On            : Sep 30, 2019
 * Description   : ASDS-1419
 ******************************************************************************/

import Action from './Action';
import CheckoutActionConstants from '../action-constants';

class ErrorActions extends Action {

    /**
     * @author: H175591
     * @description: ASDS-1419, dispatches to error page
     * @param error 
     */
    static errorPageRedirectDispatch(error: any) {
        return {
            type: CheckoutActionConstants.ERROR_HANDLER,
            payload: {
                response: {
                    errorMessage: error,
                }
            }
        }
    }

}

export default ErrorActions;